import { defineStore } from 'pinia';
import type { SigningRequestStatus } from '@Types/SigningRequestStatus.interface';

export const useSigningRequestStore = defineStore('signingRequest', {
    state: () => ({
        status: null as SigningRequestStatus | null,
        isLoading: false,
        hasCheckedStatus: false,
        validatedToken: null as string | null
    }),
    actions: {
        /**
         * Checks the signing request status for a given recipient token
         * @param recipientToken - Token from URL query parameter (passed to backend)
         */
        // async checkSigningRequestStatus(recipientToken: string): Promise<void> {
        //     try {
        //         this.isLoading = true;
        //         this.status = await getSigningRequestStatusApi(recipientToken);
        //         this.hasCheckedStatus = true;
        //         this.validatedToken = recipientToken;

        //         console.log('[Signing Request] Status checked:', this.status?.status, 'canSign:', this.status?.canSign);
        //     } catch (error) {
        //         console.error('[Signing Request] Failed to check status:', error);
        //         // On error, we'll allow the request to proceed and let backend handle validation
        //         // This prevents false positives from network issues
        //         this.status = null;
        //         this.hasCheckedStatus = true;
        //     } finally {
        //         this.isLoading = false;
        //     }
        // },

        async setValidatedToken(recipientToken: string): Promise<void> {
            this.validatedToken = recipientToken;
        },

        resetStatus(): void {
            this.status = null;
            this.hasCheckedStatus = false;
            this.isLoading = false;
            this.validatedToken = null;
        }
    }
});